import { useEffect } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import "./style/index.scss";
import { buscarTotalCadastro, buscarTotalComprovanteConsignatario, buscarTotalContaAuditoria, buscarTotalContaFinanceira, buscarTotalContabilidade } from "../../services/painelGeralService";
import FinanceiroAuditoriaPainel from "./financeiroAuditoriaContabilPainel";
import CaixaPainel from "./caixaPainel";
import FinanceiroAuditoriaContabilPainel from "./financeiroAuditoriaContabilPainel";
import { UserOutlined, TeamOutlined } from "@ant-design/icons";
import AdminPainel from "./adminPainel";
import * as Icon from "phosphor-react";
import { Flex, Skeleton } from "antd";

const PainelGeral = () => {
  //estados globais
  const persistedState = useAppSelector((state) => state.persisted);
  const painelGeralState = useAppSelector((state) => state.painelGeral);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  useEffect(() => {
    dispatch(setTitle("PAINEL GERAL"));
    switch (persistedState.user.perfil) {
      case "FINANCEIRO BASE":
        dispatch(buscarTotalContaFinanceira(persistedState.user.empresa !== null ? persistedState.user.empresa.idEmpresa : null));
        break;
      case "FINANCEIRO GERAL":
        dispatch(buscarTotalContaFinanceira(null));
        break;
      case "AUDITORIA":
        dispatch(buscarTotalContaAuditoria());
        break;
      case "CAIXA":
        dispatch(buscarTotalComprovanteConsignatario(persistedState.user.empresa !== null ? persistedState.user.empresa.idEmpresa : null));
        break;
      case "CONTABIL":
        dispatch(buscarTotalContabilidade());
        break;
      case "ADMIN":
        dispatch(buscarTotalCadastro());
        break;
      default:
        break;
    }
  }, []);

  const titles = {
    titlesFinanceiro: ["Contas a pagar", "Contas a receber"],
    titlesCaixa: ["CAP", "Entidade", "Comprovante"],
    titlesContabil: ["Anexos pendentes a pagar", "Anexos pendentes a receber", "Impostos"],
    titlesAdmin: ["Usuários", "Empresas", "Consignatários", "Pessoas"],
    titlesAuditoria: ["Despesas pendentes", "Vendas pendentes"],
  };

  const iconsAdmin = [
    {
      icon: <UserOutlined className="iconAdmin" />,
      route: "/usuario",
    },
    {
      icon: <Icon.Buildings size={50} />,
      route: "/empresa",
    },
    {
      icon: <Icon.UsersFour size={50} color="#1e1e20" />,
      route: "/consignatario",
    },
    {
      icon: <TeamOutlined className="iconAdmin" />,
      route: "/pessoa",
    },
  ];

  let componentePaginaInicial: JSX.Element | null = null;

  const tipoLogin = () => {
    switch (persistedState.user.perfil) {
      case "FINANCEIRO BASE":
        componentePaginaInicial = <FinanceiroAuditoriaContabilPainel filtro={false} titles={titles.titlesFinanceiro} contabil={false} />;
        break;
      case "FINANCEIRO GERAL":
        componentePaginaInicial = <FinanceiroAuditoriaContabilPainel filtro={true} titles={titles.titlesFinanceiro} contabil={false} />;
        break;
      case "AUDITORIA":
        componentePaginaInicial = <FinanceiroAuditoriaContabilPainel filtro={false} titles={titles.titlesAuditoria} />;
        break;
      case "CAIXA":
        componentePaginaInicial = <CaixaPainel filtro={false} titles={titles.titlesCaixa} />;
        break;
      case "CONTABIL":
        componentePaginaInicial = <FinanceiroAuditoriaPainel filtro={false} titles={titles.titlesContabil} contabil={true} />;
        break;
      case "ADMIN":
        let novaLista: any[] = [];
        if (painelGeralState.list.length !== 0) {
          novaLista = Object.values(painelGeralState.list[0]);
          novaLista.splice(0, 1);
        } else {
          novaLista = [];
        }
        componentePaginaInicial = <AdminPainel titles={titles.titlesAdmin} icons={iconsAdmin} list={novaLista} />;
        break;
      default:
        break;
    }
  };

  tipoLogin();

  return (
    <Flex vertical>
      {painelGeralState.loading ? (
        <Flex gap={12}>
          <Skeleton.Button style={{ height: 205 }} block active />
          <Skeleton.Button style={{ height: 205 }} block active />
          <Skeleton.Button style={{ height: 205 }} block active />
        </Flex>
      ) : (
        componentePaginaInicial
      )}
    </Flex>
  );
};

export default PainelGeral;
